import { render, staticRenderFns } from "./unrealizedTable.vue?vue&type=template&id=40abab9f&scoped=true&"
import script from "./unrealizedTable.vue?vue&type=script&lang=ts&"
export * from "./unrealizedTable.vue?vue&type=script&lang=ts&"
import style0 from "./unrealizedTable.vue?vue&type=style&index=0&id=40abab9f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40abab9f",
  null
  
)

export default component.exports